import React from 'react'
import { Button } from './button'
import { RxCross2 } from 'react-icons/rx'
import { LiaSaveSolid } from 'react-icons/lia'
import { t } from 'i18next'
import Loading from './Loading'

function SaveCancelButton({isEditTrue, handleSave, loading, handleCancel, disable, readOnly = false}) {
  return (
    <>
        <div className='absolute bottom-[16px] right-[20px]'>
                    <div className="flex justify-end space-x-4">
                        { disable === 'cancel' ? null : <Button
                            variant='outline'
                            style={{ color: 'hsl(var(--destructive))', background: 'white' , borderColor: 'hsl(var(--destructive))' }}
                            onClick={handleCancel}
                            disabled={loading}
                        >
                            {t('Cancel')}
                        </Button>}
                        {disable === 'save' ? null : <Button onClick={handleSave} disabled={loading || readOnly}>
                            {t(isEditTrue ? 'Update' : 'Save')}
                        </Button>}
                    </div>
                </div>
    </>
  )
}

export default SaveCancelButton